import { IChangeCategoryPositionContext } from './changeCategoryPositionContext';

export enum ChangeCategoryPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_RESTAURANT = 'SET_RESTAURANT',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_SELECT_SEARCH_STRING = 'CHANGE_SELECT_SEARCH_STRING',
}

interface ISetIDCustomer {
	type: ChangeCategoryPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IChangeCategoryPositionContext['IDSelectedCustomer'];
	};
}

interface ISetRestaurant {
	type: ChangeCategoryPositionActionTypes.SET_RESTAURANT;
	payload: {
		selectedRestaurant: IChangeCategoryPositionContext['selectedRestaurant'];
	};
}

interface IResetSelectedControls {
	type: ChangeCategoryPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeCategoryPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IChangeCategoryPositionContext['positionsData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeCategoryPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IChangeCategoryPositionContext['typeOfModalWindow'];
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangeCategoryPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisibleAdditionalRestaurantsModal: IChangeCategoryPositionContext['isVisibleAdditionalRestaurantsModal'];
		isApplyToOne: IChangeCategoryPositionContext['isApplyToOne'];
		selectedAdditionalRestaurants: IChangeCategoryPositionContext['selectedAdditionalRestaurants'];
		selectSearchString: IChangeCategoryPositionContext['selectSearchString'];
	};
}

interface IToggleApplyToOne {
	type: ChangeCategoryPositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangeCategoryPositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: IChangeCategoryPositionContext['selectedAdditionalRestaurants'];
	};
}

interface IChangeSelectSearchString {
	type: ChangeCategoryPositionActionTypes.CHANGE_SELECT_SEARCH_STRING;
	payload: {
		selectSearchString: IChangeCategoryPositionContext['selectSearchString'];
	};
}

export type TChangeCategoryPositionActions =
	| ISetIDCustomer
	| ISetRestaurant
	| IResetSelectedControls
	| ISetPositionsData
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| IChangeSelectSearchString;
